import React from 'react';
import LoginCard from '../components/LoginCard';
import AppLayout from '../layouts/AppLayout';
import { Center, Paper, Container } from '@mantine/core';
import { Head } from 'vite-react-ssg';
import { useAuth } from '../contexts/AuthContext';
import { redirectWithParameters } from '../utils/common';


const InnerLogin: React.FC = () => {
  const { isAuthenticated } = useAuth()
  if (isAuthenticated) {
    redirectWithParameters('/dashboard', {}, true)
  }
  return (
    <>
      <Container size="lg">
      <Center mx="sm">
            <Paper
                shadow="md"
                p="md"
                mt="15vh"
                radius="sm"
                withBorder={true}
            >
          <LoginCard />
        </Paper>
      </Center>
    </Container>
  </>
  );
};

const Login: React.FC = () => {
  return <AppLayout>
          <Head>
        <title>Login | Calensync</title>
      <meta name="description" content="Login and start syncing your Google, Outlook, and iCalendars together" />
    </Head>
    <InnerLogin />
  </AppLayout>
}

export default Login;
